import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {first} from 'rxjs/operators';

import {environment} from '@env/environment';
import {LocalStorageService} from '@services/local-storage.service';
import {NotificationService} from '@notifications';
import {useSpinner} from '@spinner';
import {AutoLogoutService} from '../controls/auto-logout/autologout.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationHelperService {

  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
    private localStorageService: LocalStorageService,
    private autoLogoutService: AutoLogoutService,
  ) {
  }

  /**
   * @param returnUrl in-app URL the login page returns to after the next sign-in (the AI connect page uses it)
   */
  logout(returnUrl?: string) {
    return this.http.post(environment.PUBLIC_API_URL + '/logout', {})
    .pipe(first(), useSpinner())
    .subscribe({
      next: () => {
        this.localStorageService.clearStorage();
        this.autoLogoutService.stop();
        window.location.href = returnUrl ? `/login?ref=${encodeURIComponent(returnUrl)}` : '/login';
      }, error: (error) => this.notificationService.error(error || 'Issue with logout functionality')
    });
  }
}
